var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.70996 6.47315C2.70996 5.53034 2.70996 5.05893 3.00285 4.76604C3.29575 4.47314 3.76715 4.47314 4.70996 4.47314H11.2898C12.2326 4.47314 12.704 4.47314 12.9969 4.76604C13.2898 5.05893 13.2898 5.53034 13.2898 6.47314V11.2897C13.2898 12.2325 13.2898 12.7039 12.9969 12.9968C12.704 13.2897 12.2326 13.2897 11.2898 13.2897H4.70996C3.76715 13.2897 3.29575 13.2897 3.00285 12.9968C2.70996 12.7039 2.70996 12.2325 2.70996 11.2897V6.47315Z",
    stroke: "#818291"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70996 6.47315C2.70996 5.53034 2.70996 5.05893 3.00285 4.76604C3.29575 4.47314 3.76715 4.47314 4.70996 4.47314H11.2898C12.2326 4.47314 12.704 4.47314 12.9969 4.76604C13.2898 5.05893 13.2898 5.53034 13.2898 6.47314V6.82422H2.70996V6.47315Z",
    fill: "#818291"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06104 2.70996L5.06103 4.47327",
    stroke: "#818291",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.939 2.70996L10.939 4.47327",
    stroke: "#818291",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.06104,
    y: 8,
    width: 2.35108,
    height: 1.17554,
    rx: 0.5,
    fill: "#818291"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.06104,
    y: 10.3511,
    width: 2.35108,
    height: 1.17554,
    rx: 0.5,
    fill: "#818291"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.58789,
    y: 8,
    width: 2.35108,
    height: 1.17554,
    rx: 0.5,
    fill: "#818291"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.58789,
    y: 10.3511,
    width: 2.35108,
    height: 1.17554,
    rx: 0.5,
    fill: "#818291"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.29fadbd218896a3faf469e077531c001.svg";
export { ForwardRef as ReactComponent };